import { Facet } from '../models/Facet';

/**
 * Facet which provides the user's email
 */
export const emailFacet: Facet<string> = new Facet('email');

/**
 * Facet which provides a picture of the user
 */
export const pictureFacet: Facet<string> = new Facet('picture');

/**
 * Facet which provides the user's sip
 */
export const sipFacet: Facet<string> = new Facet('sip');
